import {
  Menu,
  MenuListItem,
  Input,
  IconArrowDropUp,
  IconArrowDropDown,
  Loader
} from 'cdk-radial';
import { useEffect, useRef, useState } from 'react';
import { DropdownType } from './types';

export const Dropdown = ({
  isLoading,
  inputId,
  dataTestId,
  label,
  size,
  onChange,
  options,
  value,
  isRequired,
  isDisabled,
  errorMessage,
  hasError,
  enableCustomValidation,
  menuListStyles,
  placeHolder,
  zIndexPrinter,
  ...props
}: DropdownType): React.JSX.Element => {
  const targetRef = useRef();
  const dimensionRef = useRef();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<{
    label: string;
    value: string;
  }>({
    label: '',
    value: ''
  });

  const handleOpen = () => {
    setIsOpen(isOpenFlag => !isOpenFlag);
  };

  const handleSelect = (option: { label: string; value: string }) => {
    setSelectedOption(option);
    onChange(option);
  };

  useEffect(() => {
    if (value) {
      setSelectedOption(value);
    }
  }, [setSelectedOption, value]);

  const setDropdownIcon = isOpen ? <IconArrowDropDown /> : <IconArrowDropUp />;

  const checkLoading = isLoading ? (
    <Loader data-testid="loader" label="" />
  ) : (
    setDropdownIcon
  );

  return (
    <>
      <Input
        dataTestId={dataTestId}
        icon={checkLoading}
        id={inputId}
        label={label}
        labelRef={dimensionRef}
        name="single-select-dropdown"
        placeholder={placeHolder}
        ref={targetRef}
        value={selectedOption.label}
        size={size}
        isRequired={isRequired}
        isDisabled={isDisabled}
        errorMessage={errorMessage}
        hasError={hasError}
        onChange={() => undefined}
        enableCustomValidation={enableCustomValidation}
        {...props}
      />
      <Menu
        dimensionRef={dimensionRef}
        labelRef={targetRef}
        onClose={handleOpen}
        onOpen={handleOpen}
        isAuto={false}
        style={{
          minWidth: menuListStyles?.minWidth,
          maxWidth: menuListStyles?.maxWidth,
          zIndex: zIndexPrinter
        }}
      >
        {options.map((option, index) => (
          <MenuListItem
            dataTestId={`menu-item-${index}`}
            isSelected={option.label === selectedOption.label}
            key={option.label}
            onClick={() => handleSelect(option)}
            hideSelectedItemCheckmark={false}
          >
            {option.label}
          </MenuListItem>
        ))}
      </Menu>
    </>
  );
};
